<template>
  <div class="w-full">
    <TopNavigation />
    <MobileNavigation v-if="show" />
    <div class="flex flex-no-wrap flex-row justify-between h-full w-full" v-if="!show">
      <SideNavigation v-if="!doNotShowMenu" />
      <div class="main-content flex flex-col flex-no-wrap justify-start py-4 px-6" :class="{'mx-auto': doNotShowMenu}">
        <BreadCrumbs />
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import TopNavigation from '@/Common/components/navigation/TopNavigation.vue';
import SideNavigation from '@/Common/components/navigation/SideNavigation.vue';
import BreadCrumbs from '../components/BreadCrumbs.vue';
import MobileNavigation from '../components/navigation/MobileNavigation.vue';
import Constants from '../Constants';

export default {
  name: 'Base',
  components: {
    TopNavigation,
    SideNavigation,
    BreadCrumbs,
    MobileNavigation,
  },
  computed: {
    show() {
      return this.$store.state.Global.mobileMenu || this.$store.state.Global.subMobileMenu || this.$store.state.Global.microMobileMenu;
    },

    doNotShowMenu() {
      return Constants.doNotShowMenu.includes(this.$route.name);
    },
  },
};
</script>

<style scoped lang="scss">
  .main-content {
    flex: 0 1 100%;

    @media (min-width: 900px) {
      flex: 0 1 78%;
    }
  }
</style>
